import React from 'react';
import NextImage from 'next/image';

type ImageType = typeof NextImage;
function Image(props: React.ComponentProps<ImageType>) {
  return <NextImage {...props} />;
}
export default Image;
